export const notificationsRoutes = {
  'api.notification.store-fcm-token': 'notifications/fcm',
};
